import React, { useMemo } from 'react';
import { Card, Flex, FlexProps, Text, ListItem } from '@opendoor/bricks/core';
import { TaskCard, TaskCardProps } from 'shared/components/TaskCard';

export interface TasksSectionContentProps {
  /** Tasks to display */
  tasks: TaskCardProps[];
  /** Preferred layout to display tasks. Column by default. */
  preferredLayout?: 'column' | 'row';
  testId?: string;
}

/** Renders tasks or a card that indicates there's no more tasks to do. */
export const TasksSectionContent: React.FC<TasksSectionContentProps> = ({
  tasks,
  testId,
  preferredLayout = 'column',
}) => {
  const flexProps: FlexProps = useMemo(() => {
    if (preferredLayout === 'column') {
      return { flexDir: 'column', gridGap: 5 };
    }
    return { flexDir: ['column', null, 'row'], gridGap: 3, flexWrap: 'wrap' };
  }, [preferredLayout]);

  if (tasks.length === 0) {
    return (
      <Card variant="secondary" p={[5, null, 7]} mb={3}>
        <Flex alignItems="center" outline="0" p={0} width="100%">
          <Text ml={5} fontSize={['s1', null, 's2']} fontWeight="semibold" color="neutrals100">
            You’re all done
          </Text>
        </Flex>
      </Card>
    );
  }

  return (
    <Flex {...flexProps} as="ul" data-testid={testId}>
      {tasks.map((task) => (
        <ListItem key={task.title} flex="1">
          <TaskCard data-testid={task.title} {...task} />
        </ListItem>
      ))}
    </Flex>
  );
};
